// src/components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { RoleContext } from "../Contexts/RoleContext";
import { UserContext } from "../Contexts/LoginContext";
import BonusTopBar from "../Components/bonus/BonusTopBar";

const BONUS_TOP_BAR_ROLES = ["admin", "Manager", "Counsellor", "Visa Counsellor", "Visa&Application Counsellor"];

const MANAGER_RESTRICTED_PREFIXES = ["/users", "/settings", "/setup", "/register"];

function ProtectedRouteInner({ username, role, allowedRoles, showBonusTopBar, children }) {
  const location = useLocation();
  if (!username) return <Navigate to="/" replace />;
  const normalizedRole = (role || "").trim().toLowerCase();
  const normalizedAllowedRoles = (allowedRoles || []).map((allowedRole) => (allowedRole || "").trim().toLowerCase());
  const normalizedPath = (location?.pathname || "").trim().toLowerCase();

  const isManagerWithBroadAccess =
    normalizedRole === "manager" &&
    !MANAGER_RESTRICTED_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix));

  if (!isManagerWithBroadAccess && !normalizedAllowedRoles.includes(normalizedRole)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: "100vh",
        background: "var(--bg-page, #f4f6f8)",
      }}
    >
      {showBonusTopBar && <BonusTopBar role={role} />}
      <div className="app-main-content" style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        {children}
      </div>
    </div>
  );
}

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { role } = useContext(RoleContext);
  const { username } = useContext(UserContext);
  const showBonusTopBar = Boolean(role && BONUS_TOP_BAR_ROLES.includes(role));

  return (
    <ProtectedRouteInner
      username={username}
      role={role}
      allowedRoles={allowedRoles}
      showBonusTopBar={showBonusTopBar}
    >
      {children}
    </ProtectedRouteInner>
  );
};

export default ProtectedRoute;
